<div class="relative">
  <slot />
</div>
